// portal Bumeran and ZonaJobs

import { parseDate } from '@components/utilities/date';
import { getYear, getMonth, parse, isValid } from 'date-fns';
import { groupBy, find, trim } from 'lodash';
import { _gender, _language, _timeAvailability } from '../../constant/vacancy';
import { typesPhone, bumeranCv } from './constants';

const mapeducations = (data = []) => {
  const educations = data.map((d) => {
    const fechaInicio = parse(d.fechaInicio, 'dd-MM-yyyy', new Date());
    const fechaFin = parse(d.fechaFin, 'dd-MM-yyyy', new Date());
    const { institucionEducativa = {} } = d;
    const actualEducation = d.estadoEstudio?.id === bumeranCv.education.status.inCourse;

    return {
      degree: d.titulo,
      locality: d.pais?.id,
      intitution: institucionEducativa.id !== null ? institucionEducativa.id : institucionEducativa.nombre,
      from_month: isValid(fechaInicio) ? getMonth(fechaInicio) : null,
      from_year: isValid(fechaInicio) ? getYear(fechaInicio) : null,
      to_month: isValid(fechaFin) ? getMonth(fechaFin) : null,
      to_year: !actualEducation && isValid(fechaFin) ? getYear(fechaFin) : null,
      descript: d.descripcion,
      study_level: d.tipoEstudio?.id,
      study_status: d.estadoEstudio?.id,
      area_education: d.areaEstudio?.id,
      actual_education: actualEducation
    };
  });
  return educations;
};

function mapLanguages(data) {
  const mapeado = [];
  const Languages = data.filter((conocimiento) => conocimiento.tipo === 'Idiomas');

  Languages.forEach((element) => {
    let nombreIdioma;

    _language.forEach((language) => {
      if (language.label === element.nombre) {
        nombreIdioma = language.value;
      }
    });

    const indice = mapeado.findIndex((x) => x.language === nombreIdioma);
    const existente = mapeado[indice];

    const nivelIdioma = {
      language: nombreIdioma,
      oralLevel: existente?.oralLevel || null,
      writtenLevel: existente?.writtenLevel || null
    };

    if (element.calificador == '17') {
      nivelIdioma.oralLevel = element.nivel;
    }

    if (element.calificador == '16') {
      nivelIdioma.writtenLevel = element.nivel;
    }

    if (existente) {
      mapeado[indice] = nivelIdioma;
    } else {
      mapeado.push(nivelIdioma);
    }
  });

  return mapeado;
}

function formatDate(date) {
  if (date) {
    const day = new Date(date * 1000).getDate().toString();
    const month = new Date(date * 1000).getMonth();
    const year = new Date(date * 1000).getFullYear().toString();
    if (month < 9) {
      return `${day}-0${month + 1}-${year}`;
    }
    return `${day}-${month + 1}-${year}`;
  }
  return null;
}

function genderMatch(gender) {
  const genderlowerCase = gender?.toLowerCase();
  const gen =
    genderlowerCase === 'otro' || genderlowerCase === 'other'
      ? gender
      : _gender.find((g) => {
          if (g.value !== null) {
            return g.value.toLowerCase() === genderlowerCase || g.label.toLowerCase() === genderlowerCase;
          }
          return g.value === gender;
        })?.value || 'other';

  return gen;
}

const mapPostNavent = (items) => {
  const data = items.map((i) => {
    const dateFrom = parseDate(i.fechaInicio);
    const dateTO = parseDate(i.fechaFin);

    return {
      job: i.puesto,
      seniority: i.nivelPuesto?.id,
      company: i.empresa,
      locality: i.pais?.id,
      from_month: dateFrom?.getMonth(),
      from_year: dateFrom?.getFullYear(),
      to_month: dateTO?.getMonth(),
      to_year: dateTO?.getFullYear(),
      area: i.area?.id,
      subarea: i.subArea?.id,
      industry: i.industria?.id,
      descript: i.detalle,
      actual_job: i.fechaFin === null
    };
  });
  return data;
};

const mapLanguagesNavent = (idiomas = []) => {
  const groupName = groupBy(idiomas, 'tipo.nombre');
  const data = [];
  Object.keys(groupName).forEach((i) => {
    const writtenLevel = find(groupName[i], (d) => {
      return d.calificador.nombre === 'Escrito';
    });
    const oralLevel = find(groupName[i], (d) => {
      return d.calificador.nombre === 'Oral';
    });
    data.push({
      language: find(_language, { label: i })?.value,
      writtenLevel: writtenLevel?.nivel.id,
      oralLevel: oralLevel?.nivel.id,
      descripcion: ''
    });
  });
  return data;
};

const mapNormalizedKnowledges = (knowledges = []) => {
  const resultKnowledges = [];

  knowledges.forEach((knowledge) => {
    const knowledgeObject = {};

    if (!knowledge.id) {
      return;
    }
    knowledgeObject.id_detalle = knowledge.id;

    if (!knowledge.grupo?.nombre || ['Idiomas', 'Personalizado'].includes(knowledge.grupo?.nombre)) {
      return;
    }
    knowledgeObject.tipo = knowledge.grupo.nombre;

    if (!knowledge.tipo?.nombre) {
      return;
    }
    knowledgeObject.nombre = knowledge.tipo.nombre;

    if (!knowledge.nivel?.id) {
      return;
    }
    knowledgeObject.nivel = knowledge.nivel.id;

    if (!knowledge.conocimientoEspecifico?.nombre || !knowledge.calificador?.nombre || !knowledge.nivel?.nombre) {
      return;
    }

    knowledgeObject.descripcion = `${knowledge.conocimientoEspecifico.nombre}. ${knowledge.calificador.nombre} Nivel: ${knowledge.nivel.nombre}`;

    resultKnowledges.push(knowledgeObject);
  });

  return resultKnowledges;
};

const mapDocumentType = (type) => {
  if (type === 25 || type === 45) return 'dni';
  if (type === 27) return 'passport';
  // if (type === 26) return 'L.E.'; // Dejo comentadas estas opciones por si en un futuro las agregamos
  // if (type === 28) return 'L.C.';

  return null;
};

export const formatEducationList = (educationsList, process) => {
  educationsList.forEach((educationItem) => {
    const valuesToEval = {
      from_month: educationItem.from_month ?? null,
      to_month: educationItem.to_month ?? null
    };

    Object.keys(valuesToEval).forEach((key) => {
      const fieldValue = educationItem[key] ?? null;

      if (fieldValue !== null && !Number.isNaN(educationItem[key])) {
        if (process === 'new') {
          educationItem[key] += 1;
        } else {
          educationItem[key] = educationItem[key] > 0 ? educationItem[key] - 1 : 0;
        }
      }
    });
  });

  return educationsList;
};

export const formatJobsList = (jobsList, process) => {
  jobsList.forEach((jobItem) => {
    const valuesToEval = {
      from_month: jobItem.from_month ?? null,
      to_month: jobItem.to_month ?? null
    };

    Object.keys(valuesToEval).forEach((key) => {
      const fieldValue = jobItem[key] ?? null;

      if (fieldValue !== null && !Number.isNaN(jobItem[key])) {
        if (process === 'new') {
          jobItem[key] += 1;
        } else {
          jobItem[key] = jobItem[key] > 0 ? jobItem[key] - 1 : 0;
        }
      }
    });
  });

  return jobsList;
};

export const mapPostulantApiNavent = (data, action = 'create', requirements) => {
  const conocimientoNormalizados = groupBy(data.cv?.conocimientosNormalizados, 'grupo.nombre');
  const dni = trim(data?.numeroDocumento);
  const cv = data.cv || {};
  const direccion = data?.direccion;

  const postulant = {
    ...(requirements.address && { permanent_address: direccion }), // TODO:revisar domicilio actual
    ...(requirements.born && { born: data?.fechaNacimiento }),
    ...(requirements.dni && { dni }),
    ...(requirements.dni && { doc_num: dni }),
    ...(requirements.dni && { type_doc: mapDocumentType(data?.tipoDocumento?.id) }),
    ...(requirements.educ && { educations: mapeducations(cv?.estudios || []) }),
    ...(requirements.firstname && { firstname: data?.nombre }),
    ...(requirements.gender && { gender: genderMatch(data.genero) }),
    ...(requirements.handicapped && { discapacidad: { status: !!data.discapacidad, detalle: data.discapacidad } }),
    ...(requirements.jobs && { posts: mapPostNavent(cv?.experienciasLaborales || []) }),
    ...(requirements.language && { languages: mapLanguagesNavent(conocimientoNormalizados.Idiomas) }),
    ...(requirements.lastname && { lastname: data?.apellido }),
    ...(requirements.locality && { locality: direccion }),
    ...(requirements.locality && {
      location: {
        country: data?.paisResidencia?.id,
        province: null, // obtenemos los valores de la direccion
        city: null
      }
    }),
    ...(requirements.mail && { email: data?.email }),
    ...(requirements.mail && { emailConfirm: data?.email }),
    ...(requirements.nationality && { nationality: data.paisNacimiento?.id }),
    ...(requirements.phone && { phone: data.telefonoCelular?.numero }),
    ...(requirements.phone && { prefix_phone_1: data.telefonoCelular?.prefijo }),
    ...(requirements.phone && { type_phone_1: data.telefonoCelular.numero ? typesPhone[0].label : null }),
    ...(requirements.phone2 && { phone_2: data.telefonoFijo?.numero }),
    ...(requirements.phone2 && { prefix_phone_2: data.telefonoFijo?.prefijo }),
    ...(requirements.phone2 && { type_phone_2: data.telefonoFijo.prefijo ? typesPhone[0].label : typesPhone[1].label }),
    ...(requirements.remuneration && { desiredSalary: cv?.salarioPreferencia }),
    ...(requirements.url_perfil && { fotoURL: data?.fotoURL }),
    ...(requirements.url_perfil && { bum_img_profile: data?.fotoURL }),
    id_cv_from_bum: cv?.id,
    conocimientosNormalizados: mapNormalizedKnowledges(cv?.conocimientosNormalizados || []),
    conocimientosDesnormalizados: cv?.conocimientosDesnormalizados,
    referencias: cv?.referencias
  };

  // * Para la edición de datos importando un cv se omite modificar el mail que ya existe
  if (action === 'edit') {
    delete postulant.email;
  }
  return postulant;
};

export const mapPostulantEdit = (data) => {
  const isHighSchoolComplete = data.tags?.find((va) => {
    return va.name === 'Secundaria completa';
  })
    ? 'si'
    : 'no';

  const educationsList = data.educations ?? [];
  const jobsList = data.posts ?? [];

  const knowledges = data.conocimientos || [];
  const normalizedKnowledges = knowledges.filter(
    (knowledge) => knowledge.tipo !== 'Idiomas' && knowledge.tipo !== 'Personalizado'
  );
  const unnormalizedKnowledges = knowledges.filter((knowledge) => knowledge.tipo === 'Personalizado');

  const postulant = {
    firstname: data?.firstname,
    lastname: data.lastname === 'Sin especificar' ? null : data.lastname,
    email: data?.email,
    dni: data?.dni,
    doc_num: data?.doc_num,
    type_doc: data?.type_doc,
    prefix_phone_1: data?.prefix_phone_1,
    phone: data?.phone,
    type_phone_1: data?.type_phone_1,
    prefix_phone_2: data?.prefix_phone_2,
    phone_2: data?.phone_2,
    type_phone_2: data?.type_phone_2,
    gender: genderMatch(data.gender),
    legacy: data.legacy,
    nationality: data?.nationality, // hacer match el nombre con el ID en los countries
    location: data?.location, // objeto con los ID de la ciudad, provincia y pais
    locality: data?.locality, // String con el nombre de la ciudad, provincia y pais
    ubication: data?.ubication, // String con el nombre de la ciudad, provincia y pais (Este no lo usamos creo pero lo dejo para mas adelante discutirlo)
    permanent_address: data?.permanent_address,
    born: formatDate(data.born),
    discapacidad: data?.discapacidad,
    educations: formatEducationList(educationsList, 'edit') || [],
    languages: mapLanguages(data.conocimientos || []),
    posts: formatJobsList(jobsList, 'edit'),
    url_linkedin: data?.url_linkedin,
    url_facebook: data?.url_facebook,
    url_twitter: data?.url_twitter,
    url_skype: data?.url_skype,
    url_website: data?.url_website,
    relocation: data?.relocation?.toString() || null,
    desiredSalary: data?.desiredSalaryNumber,
    high_school_data: isHighSchoolComplete,
    available_time:
      _timeAvailability.find((time) => {
        return time.label === data.available_time;
      })?.value || null,
    additional_message: data.additional_message,
    termsConditions: {
      hiring: data?.termsConditions?.hiring,
      bumeran: data?.termsConditions?.bumeran
    },
    known: {
      relationCompany: data?.mod_known?.known,
      name: data?.mod_known?.name,
      relation: data?.mod_known?.rel
    },
    fotoURL: data.profile_image ? data.profile_image : null,
    conocimientosNormalizados: normalizedKnowledges,
    conocimientosDesnormalizados: unnormalizedKnowledges,
    showQuestions: data.showQuestions
  };

  return postulant;
};

export const getPostulantSource = (source, urlSegment = '') => {
  if (urlSegment === 'internal_jobs') {
    // Portal interno
    return 'internal';
  }

  if (typeof source === 'undefined' || !source) {
    // Micrositios y portal externo
    return 'Web';
  }

  if (source === 'referral') {
    // Panel de referentes
    return 'referral';
  }

  // TODO: Validar a partir de una lista válida de sources que la que se va a utilizar corresponda a una válida
  return source;
};

export function isFormSubmitPending(isPendingRequest, isPendingForm, isPendingReCaptchaGeneration) {
  return isPendingRequest || isPendingForm || isPendingReCaptchaGeneration;
}
